import { autoinject, transient } from "aurelia-framework";

@autoinject()
@transient()
export class RightshipInspectionUnsavedChangesDialog {

    model: { onSave: () => Promise<void>, onCancel: () => Promise<void> };

    activate(model: { onSave: () => Promise<void>, onCancel: () => Promise<void> }) {
        this.model = model;
    }

    saveChanges() {
        return new Promise<void>((resolve) => {
            const promise = this.model.onSave();
            if (promise instanceof Promise) {
                promise.then(() => {
                    resolve();
                })
            } else {
                resolve();
            }
        });
    }

    discardChanges() {
        return new Promise<void>((resolve) => {
            const promise = this.model.onCancel();
            if (promise instanceof Promise) {
                promise.then(() => {
                    resolve();
                })
            } else {
                resolve();
            }
        });
    }
}